<template>
  <gg-card>
    <gg-card-header>
      Alert Type: {{ alert.alert_title }}
    </gg-card-header>
    <gg-card-text>
      <v-row>
        <v-col cols="12">
          <v-simple-table>
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left">
                  Affected Service
                </th>
                <th class="text-left">
                  Alert Threshold
                </th>
                <th class="text-left">
                  Current Usage
                </th>
                <th class="text-left">
                  Description
                </th>
                <th class="text-left">
                  Status
                </th>
                <th class="text-left">
                  Created
                </th>
                <th class="text-left">
                  Last Notified
                </th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>
                  <div>
                    {{ alert.service }}
                  </div>
                  <div v-if="alert.subaccount_username">
                    cPanel Username: {{ alert.subaccount_username }}.
                  </div>
                </td>
                <td>{{ alert.alertThreshold }}</td>
                <td>{{ alert.currentUsage }}</td>
                <td style="white-space: normal;">{{ alert.alert_description }}</td>
                <td class="text-capitalize">
                  <v-icon small class="mb-1" :color="statusColor(alert.status)">
                    mdi-circle
                  </v-icon>
                  {{ alert.status }}
                </td>
                <td>{{ alert.created_at }}</td>
                <td>{{ alert.last_notified_at }}</td>

              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'AlertCard',
  props: {
    alert: {
      required: true,
      type: Object
    }
  },
  methods: {
    ...mapActions(['navigateTo']),
    statusColor (status) {
      switch (status) {
        case 'pending':
          return 'orange'
        case 'active':
          return 'red'
        case 'Needs Resolution':
          return 'red'
        case 'resolved':
          return 'green'
        case 'closed':
          return 'grey'
        default:
          return 'grey'
      }
    }
  }
}
</script>
